import React from "react";
import { Container, Row, Col} from "react-bootstrap";
import Work1 from "../../../Images/work-1.png";
import Work2 from "../../../Images/work-2.png";
import Work3 from "../../../Images/work-3.png";
import Work4 from "../../../Images/work-4.png";
import './PartnerWork.css'
function PartnerWork(){
    return(
        <>
            <section className="work-sc">
                <Container>
                    <Row className="align-items-center">
                        <Col xs={12}>
                            <h2 className="pageinnerhead text-center">How does our Partnership Program Work?</h2>
                            <div className="work-main">
                                <div className="work-detail detail-1">
                                    <img src={Work1} alt="work-1" className="img-fluid"></img>
                                    <p>Please fill in the application form to share your basic details</p>
                                </div>
                                <div className="work-detail detail-2">
                                    <img src={Work2} alt="work-2" className="img-fluid"></img>
                                    <p>Next, Someone from Moneysukh team will contact you to briefly discuss the opportunity</p>
                                </div>
                                <div className="work-detail detail-3">
                                    <img src={Work3} alt="work-3" className="img-fluid"></img>
                                    <p>Share the required documents to partner with us</p>
                                </div>
                                <div className="work-detail detail-4">
                                    <img src={Work4} alt="work-4" className="img-fluid"></img>
                                    <p>Welcome to Moneysukh family. You are now registered as an authorised person with Moneysukh</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default PartnerWork;